import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from 'infrastructure/common/model/api.mutation';

@Injectable({ providedIn: 'root' })
export class MarkMoodDescriptionShownApiMutation extends ApiMutation<
	void,
	void
> {
	client = 'iam';
	document = gql`
		mutation MarkMoodDescriptionShownApiMutation {
			markMoodDescriptionShown
		}
	`;
	method = 'markMoodDescriptionShown';
}
